import API, { Mode } from "../api/api";

type Param = {
  mode: Mode,
  host?: string
}
// - apiの向き先調整 -
const apiParam: Param = window.location.hostname === 'localhost'
  ? { mode: "local" }
  : { mode: "develop", host: "." }

const api = new API({mode: apiParam.mode, host: apiParam.host} );
api.on("response-error", (e: any) => {
  console.log("response error : ", e);
  throw e;
});
api.on("network-error", (e: any) => {
  console.log("network error : ", e);
});
api.on("finish", (e) => {});
export const apiAdmin = api.adminWeb();
export const apiCompany = api.companyWeb();
export const apiData = api.dataApp();

export class ApiManager {
  constructor(public type: "admin" | "company") {}

  static connectStart(id: string): string {
    // TODO ローディング状態実装
    return id;
  }

  static connectEnd(id: string) {}

  static onError = (e: any) => {};

  static errorFunc(e: any) {
    this.onError(e);
  }

  isp(callback: (api: typeof apiAdmin) => void): ApiManager {
    if (this.type === "admin") {
      callback(apiAdmin);
    }
    return this;
  }

  company(callback: (api: typeof apiCompany) => void): ApiManager {
    if (this.type === "company") {
      callback(apiCompany);
    }
    return this;
  }
}
